import { render, staticRenderFns } from "./AppStep13.vue?vue&type=template&id=3fb3b39c"
import script from "./AppStep13.vue?vue&type=script&lang=js"
export * from "./AppStep13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports